module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Make It Happen: Surrender Your Fear: Take the Leap: Live On Purpose")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cta",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "ccta",
    attrs: {
      "id": "p0009-02-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter4#toc4",
      "id": "con4"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "ccta",
    staticStyle: {
      "margin-bottom": "1.4em",
      "margin-top": "0.4em"
    },
    attrs: {
      "id": "p0009-P-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter5#toc5",
      "id": "con5"
    }
  }, [_c('i', [_vm._v("Welcome to Your Start")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctb",
    attrs: {
      "id": "p0009-P-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter6#toc6",
      "id": "con6"
    }
  }, [_c('b', [_vm._v("PART ONE: SURRENDER YOUR FEAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter7#toc7",
      "id": "con7"
    }
  }, [_vm._v("1. Stop Chasing Perfect ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8#toc8",
      "id": "con8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Meet Your Fear ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9#toc9",
      "id": "con9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. End the Extremes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#toc10",
      "id": "con10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Find an Anchor")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11#toc11",
      "id": "con11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 5. Decide You Can")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter12#toc12",
      "id": "con12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 6. Let It Go ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctb",
    attrs: {
      "id": "p0009-P-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter13#toc13",
      "id": "con13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO: TAKE THE LEAP")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter14#toc14",
      "id": "con14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Leap into Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter15#toc15",
      "id": "con15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Take a Leap of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter16#toc16",
      "id": "con16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Leap into What Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "cctb",
    attrs: {
      "id": "p0009-P-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter17#toc17",
      "id": "con17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART THREE: LIVE ON PURPOSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0009-P-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter18#toc18",
      "id": "con18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Follow the Real Success Equation ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0009-P-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter19#toc19",
      "id": "con19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Make Room for Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0009-P-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter20#toc20",
      "id": "con20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Follow Him ")])]), _vm._v(" "), _c('p', {
    staticClass: "cctb",
    attrs: {
      "id": "p0010-01-0"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter22#toc22",
      "id": "con22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART FOUR: YOUR GUIDE TO MAKE IT HAPPEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter23#toc23",
      "id": "con23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use This Guide ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter24#toc24",
      "id": "con24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 1: Evaluate Your Life")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter25#toc25",
      "id": "con25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 2: Clear the Clutter")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter26#toc26",
      "id": "con26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 3: Set Purposeful Goals ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter27#toc27",
      "id": "con27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 4: Take Action ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter28#toc28",
      "id": "con28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 5: Encourage Others ")])]), _vm._v(" "), _c('p', {
    staticClass: "ccta",
    staticStyle: {
      "margin-top": "0.8em"
    },
    attrs: {
      "id": "p0010-P-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter29#toc29",
      "id": "con29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Best Is Yet to Come")])])]), _vm._v(" "), _c('p', {
    staticClass: "ccta",
    attrs: {
      "id": "p0010-P-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter30#toc30",
      "id": "con30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "ccta",
    attrs: {
      "id": "p0010-P-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter31#toc31",
      "id": "con31",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "ccta",
    attrs: {
      "id": "p0010-P-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter32#toc32",
      "id": "con32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About")]), _vm._v(" Southern Weddings")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c854456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0